import React from 'react';
import ProductModifierGroupAdvancedSubOption from "./ProductModifierGroupAdvancedSubOption";

interface Props {
    modifierGroupOption: Record<string, any>;
    options: Record<string, any>[];
    handleAdjustOption: (state: Record<string, any>, stateIndex: number) => void;
    handleRemoveOption: ((state: Record<string, any>, stateIndex: number) => void) | undefined;
    isProductAvailable?: boolean;
    preventShowModalOnCheckingConfiguration?: boolean;
    menuId?: number;
}

const ProductModifierGroupAdvancedSubOptions = ({
                                                    modifierGroupOption,
                                                    options,
                                                    handleAdjustOption,
                                                    handleRemoveOption,
                                                    isProductAvailable,
                                                    preventShowModalOnCheckingConfiguration,
                                                    menuId
                                                }: Props) => {
    return (
        <div>
            {
                modifierGroupOption.states.map((state: Record<string, any>, index: number) => (
                    <ProductModifierGroupAdvancedSubOption
                        key={`${modifierGroupOption.id}-${state.item_id}-${index}`}
                        option={state} options={options}
                        handleAdjustOption={(state: Record<string, any>) => handleAdjustOption(state, index)}
                        position={modifierGroupOption.states.length > 1 ? index + 1 : undefined}
                        modifierGroupOption={modifierGroupOption}
                        handleRemoveOption={handleRemoveOption ? (state: Record<string, any>) => handleRemoveOption(state, index) : undefined}
                        isProductAvailable={isProductAvailable}
                        preventShowModalOnCheckingConfiguration={preventShowModalOnCheckingConfiguration}
                        menuId={menuId}
                    />
                ))
            }
        </div>
    )
}

export default ProductModifierGroupAdvancedSubOptions;